const actions = {
    MARKETING_EXPENSES_DASHBOARD_BEGIN: 'MARKETING_EXPENSES_DASHBOARD_BEGIN',
    MARKETING_EXPENSES_DASHBOARD_SUCCESS: 'MARKETING_EXPENSES_DASHBOARD_SUCCESS',
    MARKETING_EXPENSES_DASHBOARD_ERR: 'MARKETING_EXPENSES_DASHBOARD_ERR',
    STORE_MARKETING_IMAGES_GALLERY_BEGIN: 'STORE_MARKETING_IMAGES_GALLERY_BEGIN',
    STORE_MARKETING_IMAGES_GALLERY_SUCCESS: 'STORE_MARKETING_IMAGES_GALLERY_SUCCESS',
    STORE_MARKETING_IMAGES_GALLERY_ERR: 'STORE_MARKETING_IMAGES_GALLERY_ERR',

    getMarketingExpensesDashboardBegin: (month) => ({ type: actions.MARKETING_EXPENSES_DASHBOARD_BEGIN, month }),
    getMarketingExpensesDashboardSuccess: (data, month) => ({ type: actions.MARKETING_EXPENSES_DASHBOARD_SUCCESS, data, month }),
    getMarketingExpensesDashboardErr: (err, month) => ({ type: actions.MARKETING_EXPENSES_DASHBOARD_ERR, err, month }),
    getStoreMarketingImagesGalleryBegin: (month) => ({ type: actions.STORE_MARKETING_IMAGES_GALLERY_BEGIN, month }),
    getStoreMarketingImagesGallerySuccess: (data, month) => ({ type: actions.STORE_MARKETING_IMAGES_GALLERY_SUCCESS, data, month }),
    getStoreMarketingImagesGalleryErr: (err, month) => ({ type: actions.STORE_MARKETING_IMAGES_GALLERY_ERR, err, month }),
};

export default actions;
